import {
  GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS,
  GET_QUERYBUILDER_PROFILES_SUCCESS,
  GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS,
  QUERYBUILDER_API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    profileGroupList: [],
    profileList: [],
    profileFilterList: [],
    error: {},
  }
  
  const queryBuilderReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS:
        return {
          ...state,
          profileGroupList: action.payload,
        }
      
      case GET_QUERYBUILDER_PROFILES_SUCCESS:
        return {
          ...state,
          profileList: action.payload,
        }
  
      case GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS:
      return {
        ...state,
        profileFilterList: action.payload,
      }
  
      case QUERYBUILDER_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default queryBuilderReducer